
<main>
  <ng-container *ngIf="newsReady">
    <section class="bg-grey-soft ptb-60">
      <div class="container position-relative gx-5 gx-lg-0">
        <div class="row justify-content-center align-items-center">
          <div class="col-lg-6 col-12 d-flex flex-column">
            <h4 class="fw-800">{{newsDetail.Titulo}}</h4>
            <nav aria-label="breadcrumb" class="fs-12px fw-800">
              <ol class="breadcrumb mb-0">
                <li class="breadcrumb-item"><a [routerLink]="'/'">{{'navLinks.home' | translate}}</a></li>
                <li class="breadcrumb-item"><a [routerLink]="'/noticias'">{{'navLinks.noticias' | translate}}</a></li>
                <li class="breadcrumb-item active" aria-current="page">{{newsDetail.Titulo}}</li>
              </ol>
            </nav>
          </div>
          <div class="col-lg-4 col-12 mt-3 mt-lg-0 text-start text-lg-end">
            <ul class="breadcrumb mb-0">
              <li class="fw-800">{{ formattedDate }}&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;{{newsDetail.Local}}</li>
            </ul>
          </div>
        </div>
      </div>
    </section>
    <section class="mt-60 mb-60">
      <div class="container gx-5 gx-lg-0">
        <div class="row justify-content-center">
          <div class="col-12 col-lg-10" [innerHtml]="newsDetail.Texto"></div>
          <div class="col-10 col-lg-8"><img [src]="newsDetail.Imagem.url" alt="Imagem Notícias CIM Tâmega e Sousa" class="w-100 mt-40"></div>
        </div>
      </div>
    </section>
    <!--<section class="mt-60">
      <div class="container share-social-media ptb-40-80 gx-5 gx-lg-0">
        <div class="row justify-content-center">
          <div class="col-lg-12 text-center">
            <ul class="list-unstyled m-0 d-inline-flex align-items-center">
              <li><p class="mb-0 fw-700 me-3">Partilhe esta Notícia:</p></li>
              <li><a class="mx-2 facebook" [href]="socialLinks.facebook" target="_blank"><i class="uil uil-facebook color-black"></i></a></li>
              <li><a class="mx-2 twitterx" [href]="socialLinks.twitter" target="_blank"><i class="uil uil-twitter color-black"></i></a></li>
              <li><a class="mx-2 whatsapp" [href]="socialLinks.whatsapp" target="_blank"><i class="uil uil-whatsapp-alt color-black"></i></a></li>
              <li><a class="mx-2 linkedin" [href]="socialLinks.linkedin" target="_blank"><i class="uil uil-linkedin color-black"></i></a></li>
              <li><a class="mx-2 linkUrl" href="#" (click)="copyToClipboard($event)" target="_blank"><i class="uil uil-link color-black"></i></a></li>
            </ul>
          </div>
        </div>
      </div>
    </section>-->
  </ng-container>
  <section *ngIf="newsRelatedSize > 0">
    <div class="container pb-60 gx-5 gx-lg-0">
      <div class="row justify-content-center">
        <div class="col-12 col-lg-10 mx-auto text-center">
          <div class="ptb-40">
            <h6 class="fs-20px fw-700 text-uppercase text-outside-line-full">{{'newsDetail.relatedNews' | translate}}</h6>
          </div>
        </div>
      </div>
      <div class="row justify-content-center">
        <div class="col-lg-10 col-12">
          <ul class="grid grid-3col d-flex justify-content-center gap-3 flex-wrap">
            <div *ngFor="let related of newsRelated" class="col-10 col-lg-4">
              <li class="grid-item news-card">
                <div class="bg-white py-4">
                  <div class="d-block">
                    <p class="fw-700 mb-0 mt-2">{{ related.Titulo }}</p>
                    <p class="news-date-font mt-2">{{ related.formattedDate}}</p>
                    <a (click)="goToNews(related.documentId)" class="btn btn-link fw-700 px-0">{{'newsDetail.viewNewsButton' | translate}}<i class="uil uil-eye ms-2 fs-20px"></i></a>
                  </div>
                </div>
              </li>
            </div>
          </ul>
        </div>
      </div>
    </div>
  </section>
</main>

